import Caret from './Caret.jsx';

export default Caret;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/CaretWrapper/Caret/index.js